import Food from "../data/food";
import { FoodDto, PurchaseDto } from "../api";
import { FoodUnit } from "../data/foodUnit";

export function formatFoodDescription(food: Food | undefined) {
  return food
    ? food.vendor
      ? `${food.vendor} ${food.description}`
      : `${food.description}`
    : "";
}

/**
 * Liefert die Default-Einheit eines Lebensmittels. Ist keine als Default
 * markiert (kommt bei Altdaten vor), wird die erste Einheit verwendet. Foods
 * ohne Einheiten liefern `undefined`.
 */
export function getDefaultFoodUnit(food: Food): FoodUnit | undefined {
  return food.foodUnits.find((fu) => fu.isDefault) ?? food.foodUnits[0];
}

export function getDefaultPurchase(food: Food, purchases: PurchaseDto[]) {
  return purchases.find((p) => p.id === food.defaultPurchaseId);
}

export function formatFoodUnitWithAmountDescription(
  food: Food,
  foodUnit: FoodUnit,
  amount: number,
) {
  return `${formatFoodDescription(food)} ${amount.toLocaleString()} x ${foodUnit.description}`;
}

export function getFoodMaybe(
  foodUnitId: number | undefined,
  foods: FoodDto[] | undefined,
) {
  if (foodUnitId == undefined || foods == undefined) {
    return undefined;
  } else {
    const lookupResult = foods.find((f) =>
      f.foodUnits.some((fu) => fu.id === foodUnitId),
    );
    if (lookupResult === undefined) {
      console.log("Did not find food for foodUnitId", foodUnitId);
    }
    return lookupResult;
  }
}

/**
 * Wählt aus den FoodUnits eines Ziel-Foods die passende Einheit zur aktuellen
 * Einheit: gleiches Nettogewicht → 1g-Einheit → einzige Einheit → Default/erste.
 */
export function findMatchingUnit(
  currentUnit: { netWeight?: number } | undefined,
  targetFoodUnits: FoodUnit[],
): FoodUnit {
  if (!currentUnit) return targetFoodUnits[0];

  // 1. Same net weight
  if (currentUnit.netWeight !== undefined) {
    const sameWeight = targetFoodUnits.find(
      (u) => u.netWeight === currentUnit.netWeight,
    );
    if (sameWeight) return sameWeight;
  }

  // 2. 1g unit
  const gramUnit = targetFoodUnits.find((u) => u.netWeight === 1);
  if (gramUnit) return gramUnit;

  // 3. Only one unit that is not 1g
  if (targetFoodUnits.length === 1) {
    return targetFoodUnits[0];
  }

  // 4. Default or first
  const defaultUnit = targetFoodUnits.find((u) => u.isDefault);
  if (defaultUnit) return defaultUnit;
  return targetFoodUnits[0];
}

/** Rechnet die Menge beim Wechsel der Einheit über das Nettogewicht um. */
export function recalculateAmountByUnitChange(
  oldUnit: { netWeight?: number } | undefined,
  newUnit: { netWeight?: number } | undefined,
  currentAmount: number,
): number {
  if (oldUnit === undefined) {
    return currentAmount;
  }
  const oldNetWeight = oldUnit.netWeight ?? 1;
  const newNetWeight = newUnit?.netWeight ?? 1;
  if (oldNetWeight === newNetWeight) return currentAmount;
  const ratio = oldNetWeight / newNetWeight;
  return Math.round(currentAmount * ratio * 10) / 10;
}
